import { render, staticRenderFns } from "./TucatalogoFooterCard.vue?vue&type=template&id=6632322a&"
import script from "./TucatalogoFooterCard.vue?vue&type=script&lang=js&"
export * from "./TucatalogoFooterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports